import { render, staticRenderFns } from "./beneficiary-nz-bt-business.vue?vue&type=template&id=ced03588&"
import script from "./beneficiary-nz-bt-business.vue?vue&type=script&lang=js&"
export * from "./beneficiary-nz-bt-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports